import { render, staticRenderFns } from "./vehicleInsuranceEdit.vue?vue&type=template&id=6f522bac&scoped=true"
import script from "./vehicleInsuranceEdit.vue?vue&type=script&lang=js"
export * from "./vehicleInsuranceEdit.vue?vue&type=script&lang=js"
import style0 from "./vehicleInsuranceEdit.vue?vue&type=style&index=0&id=6f522bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f522bac",
  null
  
)

export default component.exports